
const PARAM_NAME = 'cjt';
const DELIMITER = '~';
const NUM_PARAMS = 6;  // number of params we actually use (currently pt, gs, pn, cn, ft, sn)

export const generateTrackingQueryParams = ({ cn, pt, gs, pn, ft, sn }) => {
	let consolidatedParams = "";
	const params = [pt, gs, pn, cn, ft, sn]; // order should match "split" in parse below
	consolidatedParams = params.join(DELIMITER);
	return consolidatedParams;
};

export const parseTrackingParams = (qParams) => {
	try {
		let searchParams = new URLSearchParams(qParams || window.location.search);

		if (searchParams.has(PARAM_NAME)) {
			const cjtTracking = searchParams.get(PARAM_NAME);
			const splitParams = cjtTracking.split(DELIMITER);
			while (splitParams.length < NUM_PARAMS) {
				splitParams.push("");
			}
			while (splitParams.length > NUM_PARAMS) {
				splitParams.pop();
			}
			const [pt, gs, pn, cn, ft, sn] = splitParams;
			return { pt, gs, pn, cn, ft, sn };
		}

		// backwards compat for individual params
		return {
			pt: searchParams.get('pt') || "",
			gs: searchParams.get('gs') || "",
			pn: searchParams.get('pn') || "",
			cn: searchParams.get('cn') || "",
			ft: searchParams.get('ft') || "",
			sn: searchParams.get('sn') || "",
		};
	} catch {
		return {
			pt: "",
			gs: "",
			pn: "",
			cn: "",
			ft: "",
			sn: "",
		};
	}
};
